import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import moment from 'moment';
import { getRatingIntFromText } from '../../../../../models/UiUtils';
import { THEME } from '../../../../../web/components-v2/Theme/theme';
import { StarIcon } from '../../../../../web/components/svgs/icons/StarIcon';
import { styleSheet } from './styles';

type ReviewCardProps = {
	onClick?: () => void;
	review: Api.IGoogleBusinessReview;
};

export const ReviewCard = ({ onClick, review }: ReviewCardProps) => {
	const ratingValue = getRatingIntFromText(review.rating) ?? 0;
	const formattedDate = review.createTime ? moment(review.createTime).format('MM/DD/YYYY') : '';
	const reviewText =
		review?.text != null ? (review.text.length > 120 ? `${review.text.slice(0, 120)}...` : review.text) : null;

	return (
		<article
			className={css(styleSheet.card, onClick && styleSheet.cardClickable)}
			onClick={onClick}
			role={onClick ? 'button' : undefined}
		>
			<div className={css(styleSheet.cardHeader)}>
				<div className={css(styleSheet.cardHeaderLeft)}>
					<span className={css(styleSheet.authorName)}>{review.reviewer?.name || review.author || 'Anonymous'}</span>
					<div className={css(styleSheet.ratingValueContainer)}>
						<StarIcon fillColor={THEME.colors.info.main} filled={true} height={12} width={12} />
						<span className={css(styleSheet.ratingValue)}>{ratingValue}</span>
					</div>
				</div>
				{formattedDate && <span className={css(styleSheet.date)}>{formattedDate}</span>}
			</div>

			{reviewText && <p className={css(styleSheet.reviewText)}>{reviewText}</p>}
		</article>
	);
};
